import { Component, Input, OnInit } from '@angular/core';
import { Link } from 'src/app/interfaces/contentful/link';
import { ContentfulService } from 'src/app/services/contentful.service';

@Component({
  selector: 'app-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss']
})
export class LinkComponent implements OnInit {

  @Input() contentId = '';

  public content: Link | undefined;
  public error: string | undefined;

  constructor(private contentfulService: ContentfulService) { }

  ngOnInit(): void {

    if (!this.content) {
      this.contentfulService.getContentItem(this.contentId)
      .then(content => {
        console.log(`[Link Component] Contentful returned the folowing for ID: ${this.contentId}`, content)
        this.content = content.fields;
      })
      .catch(error => {
        this.error = "Error: content could not be loaded."
      })
    }
  }
}
